<template lang="pug">
  .session
    .session__essence {{ caseEssence ? caseEssence : caseLawArticle }}
    v-divider.white
    .session__info

      // Левая часть
      .session__info-block
        .session__info-primary 
          b.mr-2 Дата заседания 
          b.mr-2.session__text--strong {{ courtDate }}
          | {{ courtTime }}

        .session__info-primary(v-if="!isLimitView") Доставлено 
          b.ml-2 {{ numberOfSendedDocuments }} из {{ sessionDocs.length }}

        .session__info-primary(v-if="documents.length > 0")
          .session__text--green(v-if="areAllNotified") все участники успешно извещены
          .session__text--red(v-else) не все участники извещены
      
      // Правая часть
      .session__info-block
        .session__info-secondary Дата поступления 
          b {{ dateOfReceipt }}
        .session__info-secondary В производстве 
          b {{ productionDate }}
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

let successStatuses = ['DELIVERED', 'ACQUAINTED', 'RECEIVED']

export default {
  props: {
    isLimitView: Boolean
  },

  computed: {
    ...mapGetters('courtCase', ['caseEssence', 'caseLawArticle', 'caseDateOfReceipt', 'caseDateOfProduction', 'currentSession', 'sessionDocs', 'documents']),

    dateOfReceipt () {
      return moment(this.caseDateOfReceipt).format("DD.MM.YYYY")
    },

    meetingDate () {
      let { caseStatus, eventDate } = this.currentSession
      if (eventDate && caseStatus && (caseStatus.name === "Accepted" || caseStatus.name === "CourtHearing" || caseStatus.name === "NoName")) {
        return eventDate
      }
      return null
    },

    courtDate () {
      return this.meetingDate ? moment(this.meetingDate).format("DD.MM.YYYY") : " - "
    },

    courtTime () {
      return this.meetingDate ? moment(this.meetingDate).format("HH:mm") : null
    },
    
    productionDate () {
      return this.caseDateOfProduction ? moment(this.caseDateOfProduction).format("DD.MM.YYYY") : " - "
    },

    numberOfSendedDocuments () {
      let list = this.sessionDocs.filter(d => successStatuses.includes(d.deliveryStatus.name))
      return list.length
    },

    areAllNotified () {
      return this.numberOfSendedDocuments == this.sessionDocs.length
    },
  },
}
</script>

<style lang="scss" scoped>
.session {
  background: #F0F0F0;
  padding: 11px 32px 11px 20px;
  border-radius: 5px;
}

.session__essence {
  font-family: 'Roboto Condensed', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  margin-bottom: 7px;
  color: #757575;
}

.session__info {
  display: flex;
  justify-content: space-between;
  font-family: Roboto;

  font-style: normal;
  font-weight: normal;
}

.session__info-primary {
  font-size: 16px;
  line-height: 32px;
  color: #959595;
}

.session__info-secondary {
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: #C4C4C4;
}

.session__text--strong {
  color: #757575;
}

.session__text--green {
  color: #2BC113;
}

.session__text--red {
  color: #ED0E51;
}
</style>
